import { icons } from 'src/assets/iconDef/icon.def';
export const pharmacyMenuDef = [
    {
        name: 'menu.op_order',
        icon: 'fa fa-building-o',
        data: {
            nav_url: "opCardLayout_m"
        },
        children: [{
            name: 'menu.op_sale_Walkin',
            resource: 'opCardLayout',
            icon: 'icons.application.user',
            url: 'opCardLayout',
            auto_crud: true,
            breadcrumb: 'Op Card',
            check_permission: false
        },
        {
            check_permission: false,
            auto_crud: true,
            "url": "cancel_ip_medication_order_details",
            "resource": "cancel_ip_medication_order_details"
        },
        {
            name: 'menu.op_bill_list',
            icon: icons.application.user,
            resource: 'opBillList',
            url: 'opBillList',
            auto_crud: true,
            breadcrumb: 'OP Bill List'
        },
        {
            name: 'menu.pharmacy_settlement',
            icon: 'fa fa-h-square',
            resource: 'due_settlement',
            url: '/payment/due_settlement',
            auto_crud: false,
            check_permission: false,
            redirect:true
        },
        {
            name: 'menu.pharmacy_settlement',
            icon: 'fa fa-h-square',
            resource: 'pharmacy_IP_Issue',
            url: 'pharmacy_IP_Issue',
            auto_crud: true,
            check_permission: false,
        },
        {
            name: 'menu.dispense_order',
            icon: 'fa fa-h-square',
            resource: 'dispense_order',
            url: 'dispense_order',
            auto_crud: true,
            check_permission: false,
        },
        {
            name: 'menu.pharmacy_settlement',
            icon: 'fa fa-h-square',
            resource: 'pharmacy_OP_Dispense_view_order',
            url: 'pharmacy_OP_Dispense_view_order',
            auto_crud: true,
            check_permission: false,
        },
        {
            name: 'menu.pharmacy_settlement',
            icon: 'fa fa-h-square',
            resource: 'pharmacy_IP_Issuedetails',
            url: 'pharmacy_IP_Issuedetails',
            auto_crud: true,
            check_permission: false,
        },
        {
            name: 'menu.eligibility_form',
            resource: 'eligibility_form',
            icon: 'fa fa-plus-square',
            url: 'eligibility_form',
            check_permission: false,
            auto_crud: true,
            showMenu: true
        },
        {
            name: 'menu.pharmacy_settlement',
            icon: 'fa fa-h-square',
            resource: 'pharmacy_IP_PAT_Varification',
            url: 'pharmacy_IP_PAT_Varification',
            auto_crud: true,
            check_permission: false,
        },
        {
            name: 'menu.authorization_form',
            resource: 'pharmacy_authorization',
            icon: 'fa fa-plus-square',
            url: 'pharmacy_authorization',
            check_permission: false,
            auto_crud: true,
            showMenu: true
        }
        ]
    },
    {
        name: 'menu.op_return_list',
        icon: 'fa fa-building-o',
        data: {
            nav_url: "opMedicationDirectReturn_m"
        },
        children: [
            // {
            //     name: 'menu.create_return_request_emr_op',
            //     resource: 'opReturnCardLayout',
            //     icon: 'icons.application.user',
            //     url: 'opReturnCardLayout',
            //     auto_crud: true,
            //     breadcrumb: 'Op Return Card',
            //     check_permission: false
            // },
            {
                name: 'menu.op_return_list',
                icon: icons.application.user,
                resource: 'opMedicationReturnList',
                url: 'opMedicationReturnList',
                auto_crud: true,
                breadcrumb: 'OP Issue'
            },
        ]
    },
    {
        name: 'menu.pharmacy_clearance',
        resource: 'pharmacy_clearance',
        icon: 'fa fa-plus-square',
        url: 'pharmacy_clearance',
        auto_crud: true,
        breadcrumb: 'pharmacy-clearance',
        showMenu: false,
    },
    {
        name: 'menu.ip-order',
        icon: 'fa fa-building-o',
        data: {
            nav_url: "ipMedicationOrder_m"
        },
        children: [{
            name: 'menu.ip_order_requests',
            icon: icons.application.user,
            resource: 'ipMedicationOrder',
            url: 'ipMedicationOrder',
            auto_crud: true,
            breadcrumb: 'medication Orders'
        },
        {
            name: 'menu.ip_sale_Walkin',
            resource: 'ipCardLayout',
            icon: 'icons.application.user',
            url: 'ipCardLayout',
            auto_crud: true,
            breadcrumb: 'Ip Card',
            check_permission: false
        },
        {
            name: 'menu.substitute_lookup',
            resource: 'substitute_lookup',
            icon: 'icons.application.user',
            url: 'substitute_lookup',
            auto_crud: true,
            breadcrumb: 'Ip substitute_lookup',
            check_permission: false
        },
        {
            name: 'menu.ip_issue_list',
            icon: icons.application.user,
            resource: 'ipMedicationIssue',
            url: 'ipMedicationIssue',
            auto_crud: true,
            breadcrumb: 'Ip Issue'
        }]
    },
    {
        name: 'menu.ipMedicationSplitBillRefund',
        icon: icons.application.user,
        resource: 'ipMedicationSplitBillRefund',
        url: 'ipMedicationSplitBillRefund',
        auto_crud: true,
        breadcrumb: 'ipMedicationSplitBillRefund'
    },
    {
        name: 'menu.pharmacy_IP_Split_Bill',
        icon: 'fa fa-h-square',
        resource: 'pharmacy_IP_Split_Bill',
        url: 'pharmacy_IP_Split_Bill',
        auto_crud: true,
        check_permission: false,
    },
    {
        name: 'menu.ip_return',
        icon: 'fa fa-building-o',
        data: {
            nav_url: "ipMedicationReturn_m"
        },
        children: [
            // {
            //     name: 'menu.return_request_emr_op',
            //     icon: icons.application.user,
            //     resource: 'ipMedicationReturn',
            //     url: 'ipMedicationReturn',
            //     auto_crud: true,
            //     breadcrumb: 'Return Request'
            // },
            {
                name: 'menu.ip_return_requests',
                icon: icons.application.user,
                resource: 'pendingReturnRequest',
                url: 'pendingReturnRequest',
                auto_crud: true,
                breadcrumb: 'Pending Return Request'
            },
            {
                name: 'menu.ip_return_list',
                icon: 'icons.application.user',
                resource: 'ipMedicationReturn',
                url: 'completedReturnRequest',
                auto_crud: true,
                breadcrumb: 'Completed Return Request'
            }]
    },
    {
        name: 'menu.clearance_status',
        icon: 'fa fa-h-square',
        url: 'clearance_status_pharmacy',
        auto_crud: false,
        showMenu: true
    },
    {
        resource: 'opMedicationOrder_patientLayout',
        view: 'opMedicationOrder_patientLayout',
        breadcrumb: "opMedicationOrder_patientLayout",
        name: 'menu.patientOpPharmacyOrder',
        icon: 'fa fa-h-square',
        url: 'opMedicationOrder_patientLayout',
        auto_crud: true,
        showMenu: true
    }
    
]
